import { ContainerPanel } from '@/components/Optimization/ContainerPanel';
import { PalletPanel } from '@/components/Optimization/PalletPanel';
import { CostPanel } from '@/components/Optimization/CostPanel';
import { ModeComparison } from '@/components/Optimization/ModeComparison';
import { DensityPanel } from '@/components/Optimization/DensityPanel';
import { CarrierPresets } from '@/components/Optimization/CarrierPresets';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';

interface OptimizationScreenProps {
  onErrorReport?: () => void;
}

export function OptimizationScreen({ onErrorReport }: OptimizationScreenProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
      <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-bold)' }}>
        Optimization & Cost Analysis
      </h2>

      <ErrorBoundary onReportError={onErrorReport}>
        <div className="optimization-group">
          <h3 className="optimization-group-title">Container & Packaging</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            <ContainerPanel />
            <PalletPanel />
          </div>
        </div>
      </ErrorBoundary>

      <ErrorBoundary onReportError={onErrorReport}>
        <div className="optimization-group">
          <h3 className="optimization-group-title">Cost Analysis</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            <CostPanel />
            <ModeComparison />
            <CarrierPresets />
          </div>
        </div>
      </ErrorBoundary>

      <ErrorBoundary onReportError={onErrorReport}>
        <div className="optimization-group">
          <h3 className="optimization-group-title">Cargo Insights</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            <DensityPanel />
          </div>
        </div>
      </ErrorBoundary>
    </div>
  );
}
